<template>
  <div class="flex-col item-height">
    <div class="flex-row title">
      <div class="flex-col">
        <label class="name-title">Hi {{ userInfo.englishName }}</label>
        <label class="email-title">{{ userInfo.email }}</label>
      </div>
      <div class="title-right">
        <van-image width="75px"
          height="95px"
          fit="fill"
          :src="userInfo.photoBase64" />
      </div>
    </div>
    <div class="flex-row user-center">
      <div class="flex-col center-left"
        @click="myRelationshipClick">
        <span class="iconfont iconpartership-fill center-icon"></span>
        <span style="font-size: 14px;">{{ $t("userPEVC") }}</span>
      </div>
      <div class="center-split"></div>
      <div class="flex-col center-right"
        @click="myCollectionClick">
        <span class="iconfont iconrating-fill center-icon"></span>
        <span style="font-size: 14px;">{{ $t("userCollection") }}</span>
      </div>
    </div>
    <div class="flex-col">
      <div class="flex-row  padding-item"
        @click="findHistory">
        <span class="iconfont iconarchive-fill bottom-style"></span><span class="set-name">{{$t("userQuery")}}</span>
      </div>
      <div class="flex-row"
        @click="feedback">
        <span class="iconfont iconhelp-question-fill bottom-style"></span><span class="set-name"> 问题反馈</span>
      </div>
      <div class="flex-row">
        <span class="iconfont iconinformation-fill bottom-style"></span><span class="set-name">{{$t("versionInfo")}}</span><span class="version-info">{{ versionInfo}}</span>
      </div>
      <div class="flex-row"
        @click="logout">
        <span class="iconfont iconlogin-fill bottom-style"></span><span class="set-name">{{$t("logout")}}</span>
      </div>
    </div>
    <!-- <div class="flex-row">
            <div class="flex-row" @click="logout">
                <span class="iconfont iconinformation-fill bottom-style"></span><span class="set-name">更新通知</span>
            </div>
        </div> -->
    <!-- <div style="font-size:14px;padding:10px 20px 0 20px;color:red;" v-if="showUpdate">            
               <span> 发现系统更新，请退出此程序并重新登录，谢谢。</span>            
        </div> -->
  </div>
</template>

<script>
import webService from "../../network/webService";
import _ from "lodash";
import commonjs from "../../common/common";
export default {
  name: "UserInfo",
  inject: ["reload"],
  data () {
    return {
      showUpdate: false,
      userInfo: {},
      versionInfo: '',
    };
  },
  created () {
    var userId = this.$route.params.id;
    if (!userId) {
      userId = null;
    }
    webService.getUserProfileInfo(userId).then((r) => {
      this.userInfo = r.data;
    });
    this.getVersionInfo();
  },
  methods: {
    feedback () {
      this.$router.push("/feedback");
    },
    myRelationshipClick () {
      this.$router.push({
        path: "/home/myRelationshipList/" + Math.random() * 1000000,
      });
    },
    myCollectionClick () {
      commonjs.resetTabs();
      this.$router.push({
        path: "/myFavorites/" + Math.random() * 1000000,
      });
    },
    findHistory () {
      this.$router.push({
        path: "/findHistory/" + Math.random() * 1000000,
      });
    },
    getVersionInfo () {
      var that = this;
      jsBridge.appInfo(function (info) {
        if (info && info.appVer) {
          let vInfo = info.appVer + '';
          that.versionInfo = vInfo[0] + '.' + vInfo[1] + '.' + vInfo[2];
        }
      });

      //let vinfo = '107';
      //this.versionInfo = vinfo[0] + '.' + vinfo[1] + '.' + vinfo[2];
    },
    logout () {
      webService.logout().then(() => {
        window.location.reload();
        //this.reload();
      });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../styles/theme.scss";
.title {
  background-color: #aa2417;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.email-title {
  font-size: medium;
  color: white;
  font-weight: normal;
  padding-left: 1rem;
}
.name-title {
  padding: 1rem;
  font-size: x-large;
  color: white;
  font-weight: normal;
}
.title-right {
  flex: 1;
  text-align: right;
  padding: 1rem;
}
.user-center {
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: -2rem;
  background-color: #ffffff;
  padding-bottom: 1rem;
  border: 1px solid #f2f2f2;
}
.padding-item {
  padding-top: 20px;
}
.center-left {
  flex: 1;
  text-align: center;
  padding: 1rem;
}
.center-split {
  width: 2px;
  height: 70px;
  background: #dedede;
  margin-top: 20px;
}
.center-right {
  flex: 1;
  text-align: center;
  padding: 1rem;
}
.bottom-style {
  padding: 1rem;
  size: 1.5rem;
  color: $color-gray;
}
.set-name {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.center-icon {
  color: $color-pwctheme;
  padding: 10px;
}
.version-info {
  align-items: center;
  display: flex;
  color: grey;
}
</style>


// WEBPACK FOOTER //
// src/views/profile/UserInfo.vue